import React, { useContext } from 'react'
import CheckBox from '../../common/CheckBox'
import { ConnectorViewMappingContext } from './context/context'
import { useParams } from 'react-router-dom'
import { getRandomString } from '../../../utils/common'
import { Printer } from '@styled-icons/boxicons-solid'
import DuplicateReferences from './DuplicateReferences'

const SvgViewerToolbar = (props) => {
  const { vehicle, connector_view } = useParams()

  const [state, dispatch] = useContext(ConnectorViewMappingContext)

  const toggleCheckBox = (key) => {
    dispatch({ type: key, data: !state[`${key}`] })
  }

  return (
    <div className="text-white bg-tracer-chrome-blue text-xl p-5">
      <div className="flex justify-between">
        <b className="flex-initial">Layers:</b>
        <span className="flex items-center">
          <div className="px-3">
            <CheckBox
              name="display_groups"
              value={state.displayGroups}
              checked={state.displayGroups}
              onChange={() => toggleCheckBox('displayGroups')}
            />
          </div>
          <span>SVG Groups</span>
        </span>
        <span className="flex items-center">
          <div className="px-3">
            <CheckBox
              name="display_source"
              value={state.displaySource}
              checked={state.displaySource}
              onChange={() => toggleCheckBox('displaySource')}
            />
          </div>
          <span>SVG Source</span>
        </span>
        <span className="flex items-center">
          <div className="px-3">
            <CheckBox
              name="display_mappings"
              value={state.displayMappings}
              checked={state.displayMappings}
              onChange={() => toggleCheckBox('displayMappings')}
            />
          </div>
          <span>Mappings</span>
        </span>
        <span className="flex items-center">
          <div className="px-3">
            <CheckBox
              name="display_png"
              value={state.displayPng}
              checked={state.displayPng}
              onChange={() => toggleCheckBox('displayPng')}
            />
          </div>
          <span>PNG</span>
        </span>
        <span className="flex items-center">
          <div className="px-3">
            <CheckBox
              name="display_connector"
              value={state.displayConnector}
              checked={state.displayConnector}
              onChange={() => toggleCheckBox('displayConnector')}
            />
          </div>
          <span>Connector</span>
        </span>
        <DuplicateReferences />
      </div>

      <div className="noPrint fixed-button">
        <a
          className="btn mr-2"
          href={`/vehicles/${vehicle}/connector_views/${connector_view}/print?hide-nav=${getRandomString()}`}
          target="_blank"
        >
          <Printer size="1.5rem" color="white" /> Print
        </a>
      </div>
    </div>
  )
}

export default SvgViewerToolbar
